import { IconType, SvgIcon } from './SvgIcon';

export const CameraIcon: IconType = (props) => (
  <SvgIcon {...props} viewBox="0 0 16 16">
    <path
      d="M10.6641 8.66652L14.1461 10.9879C14.1963 11.0213 14.2546 11.0404 14.3148 11.0433C14.375 11.0462 14.4349 11.0327 14.4881 11.0042C14.5412 10.9758 14.5857 10.9334 14.6167 10.8817C14.6476 10.83 14.664 10.7708 14.6641 10.7105V5.24652C14.6641 5.18787 14.6486 5.13025 14.6192 5.07948C14.5899 5.02872 14.5476 4.9866 14.4968 4.95738C14.4459 4.92817 14.3882 4.91289 14.3296 4.91309C14.2709 4.91329 14.2134 4.92896 14.1627 4.95852L10.6641 6.99985"
      stroke="currentColor"
      fill="none"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.33594 4H2.66927C1.93289 4 1.33594 4.59695 1.33594 5.33333V10.6667C1.33594 11.403 1.93289 12 2.66927 12H9.33594C10.0723 12 10.6693 11.403 10.6693 10.6667V5.33333C10.6693 4.59695 10.0723 4 9.33594 4Z"
      stroke="currentColor"
      fill="none"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

CameraIcon.displayName = 'CameraIcon';
